<template>
  <div class="realData">
    <div class="mcInfoAlarmBox" v-show="isCameraIn">
      <div>预警时间:</div>
      <div>{{ materialCarInfo.alarmTime }}</div>
    </div>
    <div class="mcInfoBox" v-show="isCameraIn">
      <div>
        <div>开启时间：</div>
        <div>{{ materialCarInfo.time }}</div>
      </div>
      <div>
        <div>喷水量：</div>
        <div>{{ materialCarInfo.sprayValue }}</div>
      </div>
      <!-- <div>
        <div>耗电量：</div>
        <div>{{ materialCarInfo.powerValue }}</div>
      </div> -->
      <div>
        <div>治理同步率：</div>
        <div>{{ materialCarInfo.num }}</div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  switchOutside, //开关厂棚外侧
  switchLight, // 开关光照
  switchTarget, // 显隐光标
  switchPillar, // 显隐藏中立柱
  switchAllEqmHL, //开关设备高亮
  switchPartEqmHL, //开关部分设备高亮
  switchSingleHL, // 单个设备高亮
  ChangePileSizeFunc, //改变料堆大小
  switchAreaWarn, //开关告警区域
  switchAreaWarnClean, //开关已治理告警区域
  switchVDM3500, //开关vdm3500
  switchVDM150, //开关vdm150
  switchVDM100, // vdm100
  switchFogGun, // 开关雾炮
  switchMediaArea, //切换视频区域
  ChangeBarrelSizeFunc, //改变堆料大小
  switchBarrel, //开关料堆
  switchEqmWarn, //开关设备报警
  SelectEquipmentFunc, //选择设备
  switchMaterialCarSim, //开关布料小车仿真
  ContinueMaterialCarSimFunc, //继续仿真
  MaterialCarTurnToPileFunc, //小车皮带转向,
  MaterialCarTurnToBarrleFunc, //小车皮带转向料桶
  MaterialCarInitCameraPosFunc, //飞跃相机
  switchCarCamera, //启停相机动画
  switchSpray, //开启喷淋和落料动画
  switchCarBelt, // 开关小车皮带
  MaterialCarMoveFunc, // 小车移动
  ScraperMoveFunc, // 挂料机移动
  ChangeChainAngleFunc, // 挂料机角度
  switchScraper, // 挂料机开关
  switchBelt, // 皮带开关
  switchTopCarBelt, // 皮带水平开关
  switchBottomCarBelt, // 皮带竖直开关
  CreateBrowserFunc,
  switchDropMat,
  DestroyBrowserFunc,
  ChangeDropPileFunc,
  CreateDropPileFunc,
  DestroyDropPileFunc,
  UnlockCameraFunc,
  backToLocationFun,
  AddStaffFunc,
  DeleteStaffFunc,
} from "@/assets/js/unity3D/shed.js";
import { ElNotification } from "element-plus";
import videoBox from "@/modules/videoComponents/videoBox.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    videoBox,
  },
  props: ["isCameraFllow"],
  inject: ["getSceenPos", "startCameraMove", "switchCF", "updateNvrInfoBox"],
  setup() {
    const openSuccess = (data, text) => {
      let word = (data ? (data[0] ? "西侧" : "东侧") : "") + text;
      ElNotification({
        type: "success",
        offset: 45,
        message: '<span style="color:white">' + word + "</span>",
        dangerouslyUseHTMLString: true,
        duration: 3000,
        customClass: "shedNote",
      });
    };
    return {
      openSuccess,
    };
  },
  data() {
    //这里存放数据
    return {
      VDM100: {},
      VDM150: {},
      VDM3500: {},
      FogGun: {},
      MaterialCar: {},
      Belt: {},
      Scraper: {},
      Detector: {},
      equipNoObj: {},
      equipStatusTimer: null,
      VDM100Status: {},
      VDM150Status: {},
      VDM3500Status: {},
      FogGunStatus: {},
      BeltStatus: {},
      ScraperStatus: {},
      DetectorStatus: {},
      MaterialCarStatus: {},
      vdm150Relate: {},
      vdm100Relate: {},
      fogRelate: {},
      vdm3500Relate: {},
      detectorRelate: {},
      beltRelate: {},
      isGetRealData: bmeConfig.getRealData,
      // 3DUI弹窗列表
      browserList: [],
      // 小车和挂料车最远移动位置
      carMostDistance: 184,
      // 镜头是否跟随
      isCameraFllowA: false,
      // 物料小车信息
      materialCarInfo: {
        time: "10:30:45",
        alarmTime: "9:57:45",
        sprayValue: "129",
        powerValue: "129",
        num: "100%",
      },
      // 镜头是否在物料小车位置
      isCameraIn: false,
      // 小车和挂料车需要校正的区域
      posLimit: [
        [20, 27],
        [46, 53],
        [72, 79],
        [98, 100],
      ],
      posLimitBase: [
        [0, 20],
        [27, 46],
        [53, 72],
        [79, 98],
      ],
      // 西侧刮板仓
      realPosLimit0: [
        [0, 60.06],
        [60.06, 109.975],
        [109.975, 149.915],
        [149.915, 204],
      ],
      // 东侧刮板仓
      realPosLimit1: [
        [0, 53.95],
        [53.95, 103.95],
        [103.95, 153.87],
        [153.87, 202.7],
      ],
      // 西侧料堆仓
      carrealPosLimit0: [
        [0, 45],
        [45, 95],
        [95, 145],
        [145, 186],
      ],
      // 东侧料堆仓
      carrealPosLimit1: [
        [0, 50],
        [50, 100],
        [100, 140],
        [140, 186],
      ],
      // 料堆最高高度
      maxMaterialHeight: 26,
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$startPushShed2.cb = this.startPushShed2;
    this.$startPushShed3.cb = this.startPushShed3;
    this.$stratSpary.cb = this.stratSpary;
    this.$camerawithSPS2.cb = this.camerawithSPS2;
    this.$camerawithSPS3.cb = this.camerawithSPS3;

    this.getDeviceFrontMapping();
    this.isGetRealData && this.getEquRealStatus();

    // this.getwaterSprayVolume();
    // setTimeout(() => {
    //   for (let m = 0; m <= 1; m++) {
    //     for (let i = 1; i <= 8; i++) {
    //       ChangeDropPileFunc(m + "," + i + ",0,1");
    //     }
    //   }
    // }, 1000);
  },
  beforeUnmount() {
    if (this.equipStatusTimer) {
      clearInterval(this.equipStatusTimer);
    }
  },
  //方法集合
  methods: {
    // 初始化映射关系 保存在本地
    async getDeviceFrontMapping() {
      let getDeviceFrontMappingUrl =
        CONFIG.requestShed + this.$apiOpt.getDeviceFrontMapping;
      let mapResult = await this.$apiUtils.get(getDeviceFrontMappingUrl, {
        customerId: this.$store.state.customerId,
      });
      // console.log(mapResult);
      mapResult.length &&
        mapResult.forEach((item) => {
          let fontId = item.frontId;
          item.deviceNo.forEach((item) => {
            this.equipNoObj[item] = fontId;
            if (fontId && fontId.indexOf("VDM150") >= 0) {
              this.vdm150Relate[fontId] = item;
            } else if (fontId && fontId.indexOf("FogGun") >= 0) {
              this.fogRelate[fontId] = item;
            } else if (fontId && fontId.indexOf("VDM3500") >= 0) {
              this.vdm3500Relate[fontId] = item;
            } else if (fontId && fontId.indexOf("Belt") >= 0) {
              this.beltRelate[fontId] = item;
            } else if (fontId && fontId.indexOf("Detector") >= 0) {
              this.detectorRelate[fontId] = item;
            } else if (fontId && fontId.indexOf("VDM100") >= 0) {
              this.vdm100Relate[fontId] = item;
            }
          });
          if (fontId && fontId.indexOf("VDM100") >= 0) {
            this.VDM100[fontId] = new Object();
            this.VDM100Status[fontId] = new Object();
            this.VDM100[fontId]["deviceNo"] = item.deviceNo;
          } else if (fontId && fontId.indexOf("VDM150") >= 0) {
            this.VDM150[fontId] = new Object();
            this.VDM150Status[fontId] = new Object();
            this.VDM150[fontId]["deviceNo"] = item.deviceNo;
          } else if (fontId && fontId.indexOf("FogGun") >= 0) {
            this.FogGun[fontId] = new Object();
            this.FogGunStatus[fontId] = new Object();
            this.FogGun[fontId]["deviceNo"] = item.deviceNo;
          } else if (fontId && fontId.indexOf("MaterialCar") >= 0) {
            this.MaterialCar[fontId] = new Object();
            this.MaterialCarStatus[fontId] = new Object();
            this.MaterialCar[fontId]["deviceNo"] = item.deviceNo;
          } else if (fontId && fontId.indexOf("VDM3500") >= 0) {
            this.VDM3500[fontId] = new Object();
            this.VDM3500Status[fontId] = new Object();
            this.VDM3500[fontId]["deviceNo"] = item.deviceNo;
          } else if (fontId && fontId.indexOf("Scraper") >= 0) {
            this.Scraper[fontId] = new Object();
            this.ScraperStatus[fontId] = new Object();
            this.Scraper[fontId]["deviceNo"] = item.deviceNo;
          } else if (fontId && fontId.indexOf("Detector") >= 0) {
            this.Detector[fontId] = new Object();
            this.DetectorStatus[fontId] = new Object();
            this.Detector[fontId]["deviceNo"] = item.deviceNo;
          } else if (fontId && fontId.indexOf("Belt") >= 0) {
            this.Belt[fontId] = new Object();
            this.BeltStatus[fontId] = new Object();
            this.Belt[fontId]["deviceNo"] = item.deviceNo;
          }
        });
      // console.log("equipNoObj:");
      // console.log(this.equipNoObj);
      this.asyncEquipID();
    },
    asyncEquipID() {
      this.$shedEquipRelate.data = {
        vdm100: this.vdm100Relate,
        vdm150: this.vdm150Relate,
        fog: this.fogRelate,
        vdm3500: this.vdm3500Relate,
        belt: this.beltRelate,
      };
      // console.log(this.$shedEquipRelate.data);
    },
    // 轮询获取状态
    getEquRealStatus() {
      if (this.equipStatusTimer) {
        clearInterval(this.equipStatusTimer);
      }
      this.equipStatusTimer = setInterval(() => {
        this.findMoistur();
        // 已接
        this.getVDM100CurRunStatus();
        this.getMaterialCarCurRunStatus();
        this.getFogGunCurRunStatus();
        this.getScraperRunStatus();
        this.getBeltRunStatus();

        this.getVDM150CurRunStatus();

        this.getVDM3500CurRunStatus();
        this.getDetectorRunStatus();
        this.getMaterialHightStatus();
        this.getPeopleSafety();
        this.renderAllStatus();
      }, 5000);
    },
    // 实时渲染
    renderAllStatus() {
      // console.log(this.VDM100Status);
      // console.log(this.VDM150Status);
      // console.log(this.MaterialCarStatus);
      // console.log(this.FogGunStatus);
      // console.log(this.ScraperStatus);
      // console.log(this.BeltStatus);

      if (JSON.stringify(this.VDM100Status) !== "{}") {
        for (let i in this.VDM100Status) {
          let item = this.VDM100Status[i];
          this.initEqm(item, i);
          switchVDM100(item.unityId, item.runStatus);
        }
      }

      if (JSON.stringify(this.VDM150Status) !== "{}") {
        for (let i in this.VDM150Status) {
          let item = this.VDM150Status[i];
          this.initEqm(item, i);
          if (item.runStatus) {
            switchVDM150(item.unityId + ",1,0,0,0.5,0.15", item.runStatus);
          } else {
            switchVDM150(item.unityId, item.runStatus);
          }
        }
      }

      if (JSON.stringify(this.VDM3500Status) !== "{}") {
        for (let i in this.VDM3500Status) {
          let item = this.VDM3500Status[i];
          this.initEqm(item, i);
          switchVDM3500(item.unityId, item.runStatus);
        }
      }
      if (JSON.stringify(this.FogGunStatus) !== "{}") {
        for (let i in this.FogGunStatus) {
          let item = this.FogGunStatus[i];
          this.initEqm(item, i);
          if (item.runStatus) {
            switchFogGun(item.unityId + "," + item.rotate, item.runStatus);
          } else {
            switchFogGun(item.unityId, item.runStatus);
          }
        }
      }

      if (JSON.stringify(this.MaterialCarStatus) !== "{}") {
        for (let i in this.MaterialCarStatus) {
          let item = this.MaterialCarStatus[i];
          this.initEqm(item, i);
          // 反转
          item.hasOwnProperty("rotateConversion") &&
            item.rotateConversion &&
            MaterialCarTurnToBarrleFunc(item.unityId);
          // 正转
          item.hasOwnProperty("rotateForeward") &&
            item.rotateConversion &&
            MaterialCarTurnToPileFunc(item.unityId);
          if (item.hasOwnProperty("beltRunStatus")) {
            switchTopCarBelt(item.unityId, item.beltRunStatus);
            switchBottomCarBelt(item.unityId, item.beltRunStatus);
          }
          if (item.hasOwnProperty("runStatus")) {
            switchSpray(item.unityId, item.runStatus);
          }
          item.hasOwnProperty("pos") &&
            MaterialCarMoveFunc(item.unityId + "," + item.pos + ",5");
        }
      }

      // console.log(this.ScraperStatus);
      if (JSON.stringify(this.ScraperStatus) !== "{}") {
        for (let i in this.ScraperStatus) {
          let item = this.ScraperStatus[i];
          this.initEqm(item, i);
          item.hasOwnProperty("pos") &&
            ScraperMoveFunc(item.unityId + "," + item.pos + ",5");
          item.hasOwnProperty("runStatus") &&
            switchScraper(item.unityId, item.runStatus);
          item.hasOwnProperty("rotate") &&
            ChangeChainAngleFunc(item.unityId + "," + item.rotate);
          if (item.runStatus) {
            DestroyDropPileFunc(item.posAreaID);
          }
        }
      }

      if (JSON.stringify(this.BeltStatus) !== "{}") {
        for (let i in this.BeltStatus) {
          let item = this.BeltStatus[i];
          this.initEqm(item, i);
          item.hasOwnProperty("runStatus") &&
            switchBelt(item.unityId, item.runStatus);
        }
      }

      if (JSON.stringify(this.MaterialHightStatus) !== "{}") {
        for (let i in this.MaterialHightStatus) {
          let item = this.MaterialHightStatus[i];
          item.hasOwnProperty("height") &&
            ChangePileSizeFunc(this.substrId(item.unityId) + "," + item.height);
        }
      }
    },
    initEqm(item, i) {
      // 运行状态
      if (item.runStatus) {
        switchSingleHL(i, item.runStatus);
      } else {
        switchSingleHL(i, item.runStatus);
      }
      // 告警状态
      if (item.alarmStatus) {
        switchEqmWarn(i, item.alarmStatus);
      } else {
        switchEqmWarn(i, item.alarmStatus);
      }
    },
    // 设备运行状态
    createBrowserBox(item, i) {
      // if (item.runStatus && !this.browserList.includes(i + ",baseInfo")) {
      //   console.log(i, item);
      //   CreateBrowserFunc(
      //     0,
      //     i,
      //     {
      //       runStatus: item.runStatus,
      //       no: i.replace(item.unityId + ",", ""),
      //       deviceNos: item.deviceNo,
      //     },
      //     "baseInfo"
      //   );
      //   this.browserList.push(i + ",baseInfo");
      // } else {
      //   DestroyBrowserFunc(i + ",baseInfo");
      //   this.browserList = this.browserList.filter((m) => {
      //     m != i + ",baseInfo";
      //   });
      // }
    },
    cbEquRealdata(fontId, deviceNoList, name, offsetY = 2) {
      // console.log(fontId, deviceNoList, name)
      if (!this.browserList.includes(fontId + ",realdata")) {
        CreateBrowserFunc(
          2,
          fontId,
          {
            deviceNoList,
            customerId: this.$store.state.customerId,
            type: name,
          },
          "realdata",
          [0, offsetY, 0]
        );
        this.browserList.push(fontId + ",realdata");
      }
    },
    // vdm100
    async getVDM100CurRunStatus() {
      let signalIds = [];
      for (let i in this.VDM100) {
        let tmpEquip = this.VDM100[i]["deviceNo"];
        tmpEquip.forEach((item) => {
          signalIds.push(item);
        });
      }

      if (signalIds.length > 0) {
        let findRealtimeDeviceListAllUrl =
          CONFIG.requestShed + this.$apiOpt.findRealtimeDeviceListAll;
        let devicesStatus = await this.$apiUtils.get(
          findRealtimeDeviceListAllUrl,
          {
            customerId: this.$store.state.customerId,
            deviceNoList: signalIds.join(","),
          }
        );
        // console.log(devicesStatus);
        devicesStatus &&
          devicesStatus.forEach((item) => {
            let deviceNo = item.deviceNo;
            let fontId = this.equipNoObj[deviceNo];
            this.cbEquRealdata(fontId, deviceNo, "VDM100", 5);
            if (fontId) {
              let signalRealtimeValueList = item.signalRealtimeValueList;
              let alarmStatus = false;
              let alarmPicUrl = "";
              let runStatus = false;
              let runVal = "";
              let runValUnit = "";
              for (let j in signalRealtimeValueList) {
                if (signalRealtimeValueList[j]["categoryId"] === 263) {
                  if (signalRealtimeValueList[j]["value"]) {
                    runVal = signalRealtimeValueList[j]["value"];
                    runValUnit = signalRealtimeValueList[j]["unit"];
                    runStatus = true;
                  }
                }
                if (signalRealtimeValueList[j]["categoryId"] === 269) {
                  if (signalRealtimeValueList[j]["value"]) {
                    alarmStatus = true;
                  }
                }
                if (signalRealtimeValueList[j]["categoryId"] === 268) {
                  if (signalRealtimeValueList[j]["value"]) {
                    alarmPicUrl = signalRealtimeValueList[j]["value"];
                  }
                }
                this.VDM100Status[fontId] = {
                  name: item.deviceName,
                  no: item.deviceNo,
                  typeId: item.typeId,
                  alarmStatus: alarmStatus,
                  alarmPicUrl: alarmPicUrl,
                  runValUnit,
                  runStatus: runStatus,
                  runVal: runVal,
                  unityId: fontId.replace(",VDM100", ""),
                };
              }
            }
          });
      }
      // console.log(this.VDM100Status);
    },
    // vdm150
    async getVDM150CurRunStatus() {
      let deviceNos = [];
      for (let i in this.VDM150) {
        let tmpEquip = this.VDM150[i]["deviceNo"];
        tmpEquip.forEach((item) => {
          deviceNos.push(item);
        });
      }

      if (deviceNos.length > 0) {
        let findRealtimeDeviceListAllUrl =
          CONFIG.requestShed + this.$apiOpt.findRealtimeDeviceListAll;
        let devicesStatus = await this.$apiUtils.get(
          findRealtimeDeviceListAllUrl,
          {
            customerId: this.$store.state.customerId,
            deviceNoList: deviceNos.join(","),
          }
        );
        // console.log(devicesStatus);

        devicesStatus &&
          devicesStatus.forEach((item) => {
            let deviceNo = item.deviceNo;
            let fontId = this.equipNoObj[deviceNo];
            this.cbEquRealdata(fontId, deviceNo, "VDM150");
            if (fontId) {
              let signalRealtimeValueList = item.signalRealtimeValueList;
              let alarmStatus = false;
              let alarmPicUrl = "";
              let runStatus = false;
              let runValUnit = "";
              let runVal = "";
              let rotate = "";
              for (let j in signalRealtimeValueList) {
                if (signalRealtimeValueList[j]["categoryId"] === 263) {
                  if (signalRealtimeValueList[j]["value"]) {
                    runVal = signalRealtimeValueList[j]["value"];
                    runValUnit = signalRealtimeValueList[j]["unit"];
                    runStatus = true;
                  }
                }
                if (signalRealtimeValueList[j]["categoryId"] === 269) {
                  if (signalRealtimeValueList[j]["value"]) {
                    alarmStatus = true;
                  }
                }
                if (signalRealtimeValueList[j]["categoryId"] === 268) {
                  if (signalRealtimeValueList[j]["value"]) {
                    alarmPicUrl = signalRealtimeValueList[j]["value"];
                  }
                }
                if (signalRealtimeValueList[j]["categoryId"] === 15) {
                  if (signalRealtimeValueList[j]["value"]) {
                    rotate = signalRealtimeValueList[j]["value"];
                  }
                }
              }
              this.VDM150Status[fontId] = {
                name: item.deviceName,
                no: item.deviceNo,
                typeId: item.typeId,
                alarmStatus: alarmStatus,
                alarmPicUrl: alarmPicUrl,
                runStatus: runStatus,
                runVal: runVal,
                runValUnit,
                rotate,
                unityId: fontId.replace(",VDM150", ""),
              };
            }
          });
      }
      // console.log(this.VDM150Status);
    },
    // vdm3500
    async getVDM3500CurRunStatus() {
      let deviceNos = [];
      for (let i in this.VDM3500) {
        let tmpEquip = this.VDM3500[i]["deviceNo"];
        tmpEquip.forEach((item) => {
          deviceNos.push(item);
        });
      }
      if (deviceNos.length > 0) {
        let findRealtimeDeviceListAllUrl =
          CONFIG.requestShed + this.$apiOpt.findRealtimeDeviceListAll;
        let devicesStatus = await this.$apiUtils.get(
          findRealtimeDeviceListAllUrl,
          {
            customerId: this.$store.state.customerId,
            deviceNoList: deviceNos.join(","),
          }
        );
        // console.log(devicesStatus);

        devicesStatus &&
          devicesStatus.forEach((item) => {
            let deviceNo = item.deviceNo;
            let fontId = this.equipNoObj[deviceNo];
            this.cbEquRealdata(fontId, deviceNo, "VDM3500");
            if (fontId) {
              let signalRealtimeValueList = item.signalRealtimeValueList;
              let alarmStatus = false;
              let alarmPicUrl = "";
              let runStatus = false;
              let runValUnit = "";
              let runVal = "";
              for (let j in signalRealtimeValueList) {
                if (signalRealtimeValueList[j]["categoryId"] === 263) {
                  if (signalRealtimeValueList[j]["value"]) {
                    runVal = signalRealtimeValueList[j]["value"];
                    runValUnit = signalRealtimeValueList[j]["unit"];
                    runStatus = true;
                  }
                }
                if (signalRealtimeValueList[j]["categoryId"] === 269) {
                  if (signalRealtimeValueList[j]["value"]) {
                    alarmStatus = true;
                  }
                }
                if (signalRealtimeValueList[j]["categoryId"] === 268) {
                  if (signalRealtimeValueList[j]["value"]) {
                    alarmPicUrl = signalRealtimeValueList[j]["value"];
                  }
                }
              }
              this.VDM3500Status[fontId] = {
                name: item.deviceName,
                no: item.deviceNo,
                typeId: item.typeId,
                alarmStatus: alarmStatus,
                alarmPicUrl: alarmPicUrl,
                runStatus: runStatus,
                runVal: runVal,
                runValUnit,
                unityId: fontId.replace(",VDM3500", ""),
              };
            }
          });
        // console.log(this.VDM3500Status);
      }
    },
    // 雾炮
    async getFogGunCurRunStatus() {
      let signalIds = [];
      for (let i in this.FogGun) {
        let tmpEquip = this.FogGun[i]["deviceNo"];
        tmpEquip.forEach((item) => {
          signalIds.push(item);
        });
      }

      if (signalIds.length > 0) {
        let findRealtimeDeviceListAllUrl =
          CONFIG.requestShed + this.$apiOpt.findRealtimeDeviceListAll;
        let devicesStatus = await this.$apiUtils.get(
          findRealtimeDeviceListAllUrl,
          {
            customerId: this.$store.state.customerId,
            deviceNoList: signalIds.join(","),
          }
        );
        // console.log(devicesStatus);
        devicesStatus &&
          devicesStatus.forEach((item) => {
            let deviceNo = item.deviceNo;
            let fontId = this.equipNoObj[deviceNo];
            this.cbEquRealdata(fontId, deviceNo, "FogGun");
            if (fontId) {
              let signalRealtimeValueList = item.signalRealtimeValueList;
              for (let j in signalRealtimeValueList) {
                if (
                  signalRealtimeValueList[j]["categoryId"] === 1 ||
                  signalRealtimeValueList[j]["categoryId"] === 30
                ) {
                  if (
                    !this.FogGunStatus[fontId]["runStatus"] &&
                    signalRealtimeValueList[j]["value"]
                  ) {
                    setTimeout(() => {
                      this.openSuccess(false, item.deviceName + "开启治理");
                    }, 0);
                  }
                  this.FogGunStatus[fontId]["runVal"] =
                    signalRealtimeValueList[j]["value"];
                  this.FogGunStatus[fontId]["runStatus"] =
                    !!signalRealtimeValueList[j]["value"];
                }
                if (signalRealtimeValueList[j]["categoryId"] == 15) {
                  this.FogGunStatus[fontId]["rotate"] =
                    signalRealtimeValueList[j]["value"];
                }
              }
              Object.assign(this.FogGunStatus[fontId], {
                name: item.deviceName,
                no: item.deviceNo,
                unityId: fontId.replace(",FogGun", ""),
              });
            }
          });
        // console.log(this.FogGunStatus);
      }
    },
    // 物料车
    async getMaterialCarCurRunStatus() {
      let signalIds = [];
      for (let i in this.MaterialCar) {
        let tmpEquip = this.MaterialCar[i]["deviceNo"];
        tmpEquip.forEach((item) => {
          signalIds.push(item);
        });
      }

      if (signalIds.length > 0) {
        let findRealtimeDeviceListAllUrl =
          CONFIG.requestShed + this.$apiOpt.findRealtimeDeviceListAll;
        let devicesStatus = await this.$apiUtils.get(
          findRealtimeDeviceListAllUrl,
          {
            customerId: this.$store.state.customerId,
            deviceNoList: signalIds.join(","),
          }
        );
        // console.log(devicesStatus);
        devicesStatus &&
          devicesStatus.forEach((item) => {
            let fontId = this.equipNoObj[item.deviceNo];
            if (fontId) {
              let rotateForeward = false;
              let rotateConversion = false;
              let signalRealtimeValueList = item.signalRealtimeValueList;
              if (item.deviceName.indexOf("干雾") > -1) {
                this.MaterialCarStatus[fontId]["deviceNo"] = item.deviceNo;
              }
              for (let j in signalRealtimeValueList) {
                if (
                  // typeId 1则是检测设备
                  (signalRealtimeValueList[j]["categoryId"] === 1 ||
                    signalRealtimeValueList[j]["categoryId"] === 30) &&
                  item.typeId !== 1
                ) {
                  this.MaterialCarStatus[fontId]["runStatus"] =
                    signalRealtimeValueList[j]["value"];
                  this.MaterialCarStatus[fontId]["runStatus"] =
                    !!signalRealtimeValueList[j]["value"];
                }
                if (signalRealtimeValueList[j]["categoryId"] === 13) {
                  if (signalRealtimeValueList[j]["value"]) {
                    let pos = signalRealtimeValueList[j]["value"];
                    let direction = fontId[0];
                    let posPercent, areaId;
                    this["carrealPosLimit" + direction].forEach(
                      (i, index, arr) => {
                        if (pos < 0) {
                          this.MaterialCarStatus[fontId]["pos"] = 0;
                          areaId = 0;
                        } else if (pos > arr[3][1]) {
                          this.MaterialCarStatus[fontId]["pos"] =
                            arr[arr.length - 1][1];
                          areaId = 8;
                        }
                        if (i[0] <= pos && i[1] >= pos) {
                          if (pos - i[0] > (i[1] - i[0]) / 2) {
                            posPercent = 0.75;
                          } else {
                            posPercent = 0.25;
                          }
                          this.MaterialCarStatus[fontId]["pos"] = (
                            this.posLimitBase[index][0] +
                            (this.posLimitBase[index][1] -
                              this.posLimitBase[index][0]) *
                              posPercent
                          ).toFixed(2);
                          if (posPercent > 0.5) {
                            areaId = 7 - index * 2;
                          } else {
                            areaId = 8 - index * 2;
                          }
                        }
                        this.MaterialCarStatus[fontId]["posAreaID"] =
                          fontId.substr(0, 2) + areaId;
                      }
                    );
                  }
                }
                if (
                  signalRealtimeValueList[j]["signalName"] === "正转运行信号"
                ) {
                  rotateForeward = !!signalRealtimeValueList[j]["value"];
                }
                if (
                  signalRealtimeValueList[j]["signalName"] === "反转运行信号"
                ) {
                  rotateConversion = !!signalRealtimeValueList[j]["value"];
                }
              }

              Object.assign(this.MaterialCarStatus[fontId], {
                name: item.deviceName,
                typeId: item.typeId,
                unityId: fontId.replace(",MaterialCar", ""),
                rotateForeward,
                rotateConversion,
                beltRunStatus: rotateForeward || rotateConversion,
              });
            }
          });
        // console.log(this.MaterialCarStatus);
      }
    },
    // 挂料车
    async getScraperRunStatus() {
      let deviceNos = [];
      for (let i in this.Scraper) {
        let tmpEquip = this.Scraper[i]["deviceNo"];
        tmpEquip.forEach((item) => {
          deviceNos.push(item);
        });
      }

      if (deviceNos.length > 0) {
        let findRealtimeDeviceListAllUrl =
          CONFIG.requestShed + this.$apiOpt.findRealtimeDeviceListAll;
        let devicesStatus = await this.$apiUtils.get(
          findRealtimeDeviceListAllUrl,
          {
            customerId: this.$store.state.customerId,
            deviceNoList: deviceNos.join(","),
          }
        );
        // console.log(devicesStatus);
        devicesStatus &&
          devicesStatus.forEach((item) => {
            let deviceNo = item.deviceNo;
            let fontId = this.equipNoObj[deviceNo];
            if (fontId) {
              let signalRealtimeValueList = item.signalRealtimeValueList;
              for (let j in signalRealtimeValueList) {
                if (signalRealtimeValueList[j]["categoryId"] === 13) {
                  if (signalRealtimeValueList[j]["value"]) {
                    let pos = signalRealtimeValueList[j]["value"];
                    let direction = fontId[0];
                    let posPercent, areaId;
                    this["realPosLimit" + direction].forEach(
                      (i, index, arr) => {
                        if (pos < 0) {
                          this.ScraperStatus[fontId]["pos"] = 0;
                          areaId = 0;
                        } else if (pos > arr[3][1]) {
                          this.ScraperStatus[fontId]["pos"] =
                            arr[arr.length - 1][1];
                          areaId = 8;
                        }
                        if (i[0] <= pos && i[1] >= pos) {
                          posPercent = ((pos - i[0]) / (i[1] - i[0])).toFixed(
                            2
                          );
                          this.ScraperStatus[fontId]["pos"] = (
                            this.posLimitBase[index][0] +
                            (this.posLimitBase[index][1] -
                              this.posLimitBase[index][0]) *
                              posPercent
                          ).toFixed(2);
                          if (posPercent > 0.5) {
                            areaId = 7 - index * 2;
                          } else {
                            areaId = 8 - index * 2;
                          }
                        }
                        this.ScraperStatus[fontId]["posAreaID"] =
                          fontId.substr(0, 2) + areaId;
                      }
                    );
                  }
                }
                if (signalRealtimeValueList[j]["categoryId"] === 15) {
                  if (signalRealtimeValueList[j]["value"]) {
                    this.ScraperStatus[fontId]["rotate"] =
                      signalRealtimeValueList[j]["value"] + 8 > 62
                        ? 62
                        : signalRealtimeValueList[j]["value"] + 8;
                  }
                }
                if (
                  signalRealtimeValueList[j]["categoryId"] === 1 ||
                  signalRealtimeValueList[j]["categoryId"] === 30
                ) {
                  this.ScraperStatus[fontId]["runStatus"] =
                    !!signalRealtimeValueList[j]["value"];
                }
              }
              Object.assign(this.ScraperStatus[fontId], {
                name: item.deviceName,
                no: item.deviceNo,
                unityId: fontId.replace(",Scraper", ""),
              });
            }
          });
        // console.log(this.ScraperStatus);
      }
    },
    // 皮带
    async getBeltRunStatus() {
      let deviceNos = [];
      for (let i in this.Belt) {
        let tmpEquip = this.Belt[i]["deviceNo"];
        tmpEquip.forEach((item) => {
          deviceNos.push(item);
        });
      }

      if (deviceNos.length > 0) {
        let findRealtimeDeviceListAllUrl =
          CONFIG.requestShed + this.$apiOpt.findRealtimeDeviceListAll;
        let devicesStatus = await this.$apiUtils.get(
          findRealtimeDeviceListAllUrl,
          {
            customerId: this.$store.state.customerId,
            deviceNoList: deviceNos.join(","),
          }
        );
        // console.log(devicesStatus);
        devicesStatus &&
          devicesStatus.forEach((item) => {
            let deviceNo = item.deviceNo;
            let fontId = this.equipNoObj[deviceNo];
            this.cbEquRealdata(fontId.substr(0, 4) + "Arrow", deviceNo, "Belt");
            if (fontId) {
              let runStatus = false;
              let runValue = 0;
              let signalRealtimeValueList = item.signalRealtimeValueList;
              for (let j in signalRealtimeValueList) {
                if (signalRealtimeValueList[j]["categoryId"] === 1) {
                  if (signalRealtimeValueList[j]["value"]) {
                    runStatus = true;
                  }
                }
                if (signalRealtimeValueList[j]["categoryId"] === 2) {
                  if (signalRealtimeValueList[j]["value"]) {
                    runValue = signalRealtimeValueList[j]["value"];
                  }
                }
              }
              this.BeltStatus[fontId] = {
                name: item.deviceName,
                no: item.deviceNo,
                runStatus,
                runValue,
                unityId: fontId.replace(",Belt", ""),
              };
            }
          });
        // console.log(this.BeltStatus);
      }
    },
    async findMoistur() {
      let findMoisturUrl = CONFIG.requestShed + this.$apiOpt.findMoistur;
      let moisturValue = await this.$apiUtils.get(findMoisturUrl, {
        customerId: this.$store.state.customerId,
        // deviceNos: deviceNos.join(","),
      });
      if (moisturValue) {
        this.moisturRegion = moisturValue;
      }
    },
    // 含水率检测仪
    async getDetectorRunStatus() {
      let deviceNos = [];
      for (let i in this.Detector) {
        let tmpEquip = this.Detector[i]["deviceNo"];
        tmpEquip.forEach((item) => {
          deviceNos.push(item);
        });
      }

      if (deviceNos.length > 0) {
        let findRealWaterUrl = CONFIG.requestShed + this.$apiOpt.findRealWater;
        let devicesStatus = await this.$apiUtils.get(findRealWaterUrl, {
          customerId: this.$store.state.customerId,
          // deviceNos: deviceNos.join(","),
        });

        Object.keys(devicesStatus) &&
          Object.keys(devicesStatus).forEach((key) => {
            let item = devicesStatus[key];
            let fontId = this.equipNoObj[item.deviceNo];
            if (!fontId) return;
            this.DetectorStatus[fontId]["deviceNo"] = item.deviceNo;
            this.DetectorStatus[fontId]["time"] = item.time;
            this.DetectorStatus[fontId]["value"] = item.value;
            // 处理含水率监测仪下的皮带数据
            if (item.moisturePdResult) {
              let beltObj = JSON.parse(JSON.stringify(item.moisturePdResult));
              // console.log(beltObj);
              beltObj.runValue = beltObj.value && beltObj.value;
              beltObj.runStatus = beltObj.value && beltObj.value > 0;
              beltObj.unityId = beltObj["frontId"].substr(0, 3);
              this.BeltStatus[beltObj["frontId"]] = beltObj;
              this.cbEquRealdata(
                beltObj["frontId"].substr(0, 4) + "Arrow",
                item.deviceNo,
                "Belt"
              );
            }

            // 判断是否上料 默认值6-20
            let region;
            if (this.DetectorStatus[fontId]["deviceNo"] == "42-HBLP-ME4741") {
              region = this.moisturRegion.filter((i) => {
                return i.device_no == "42-HBLP-ME4741";
              })[0] || {
                max_moisture: "20",
                min_moisture: "3",
              };
              this.DetectorStatus[fontId]["isRun"] =
                item.value > region.min_moisture &&
                item.value < region.max_moisture;
            } else {
              region = this.moisturRegion.filter((i) => {
                return i.device_no == "42-HBLP-ME4740";
              })[0] || {
                max_moisture: "20",
                min_moisture: "0.5",
              };
              this.DetectorStatus[fontId]["isRun"] =
                item.value > region.min_moisture &&
                item.value < region.max_moisture;
            }

            // 判断是否开始送料 已开始送料就不重复执行动画了
            if (
              this.DetectorStatus[fontId]["isRun"] &&
              !this.DetectorStatus[fontId]["isAnimation"]
            ) {
              this.startPushShed1(fontId.substr(0, 3));
              this.materialCarInfo.alarmTime = this.DetectorStatus[fontId].time;
              this.materialCarInfo.time = this.DetectorStatus[fontId].time;
              this.DetectorStatus[fontId]["isAnimation"] = true;
            } else if (
              !this.DetectorStatus[fontId]["isRun"] &&
              this.DetectorStatus[fontId]["isAnimation"]
            ) {
              switchMaterialCarSim(fontId.substr(0, 3), false);
              switchDropMat(this.substrId(fontId), false);
              switchSpray(this.substrId(fontId), false);
              this.DetectorStatus[fontId]["isAnimation"] = false;
              // backToLocationFun("0,0,0");
            }
          });
        // console.log(this.DetectorStatus);
        // 创建含水率检测仪面板
        let detectorList = {
          "0,1,Detector": "42-HBLP-ME4741",
          "1,1,Detector": "42-HBLP-ME4740",
        };
        Object.keys(detectorList).forEach((item) => {
          if (!this.browserList.includes(item + ",baseInfo")) {
            CreateBrowserFunc(
              1,
              item,
              {
                customerId: this.$store.state.customerId,
                deviceNos: detectorList[item],
              },
              "baseInfo",
              [0, 10, 0]
            );
            this.browserList.push(item + ",baseInfo");
          }
        });
        // console.log(this.DetectorStatus);
      }
    },
    async getMaterialHightStatus() {
      let findMaterialHightUrl =
        CONFIG.requestShed + this.$apiOpt.findMaterialHight;
      let materialHight = await this.$apiUtils.get(findMaterialHightUrl, {
        customerId: this.$store.state.customerId,
        shedNo: "42_101",
      });
      // console.log(materialHight);
      if (materialHight) {
        this.MaterialHightStatus = materialHight;
        for (let i in this.MaterialHightStatus) {
          ChangePileSizeFunc(
            i.substr(0, 3) +
              "," +
              (this.MaterialHightStatus[i] * 100) / this.maxMaterialHeight
          );
          // ChangeDropPile(i.substr(0, 3) + ",0,10");
        }
      }
    },
    // 获取同步率
    async getgovernanceRate(deviceNo = "42-HBLP-ME4741") {
      let findgovernanceRateUrl =
        CONFIG.requestShed + this.$apiOpt.findgovernanceRate;
      let governanceRate = await this.$apiUtils.get(findgovernanceRateUrl, {
        customerId: this.$store.state.customerId,
        deviceNo: deviceNo,
      });
      if (governanceRate) {
        this.materialCarInfo.num = governanceRate["同步率"];
      }
    },
    // 获取喷水量
    async getwaterSprayVolume(deviceNo = "42-HBLP-GW-002") {
      let findwaterSprayVolumeUrl =
        CONFIG.requestShed + this.$apiOpt.findwaterSprayVolume;
      let waterSprayVolume = await this.$apiUtils.get(findwaterSprayVolumeUrl, {
        customerId: this.$store.state.customerId,
        deviceNo: deviceNo,
      });
      if (waterSprayVolume) {
        this.materialCarInfo.sprayValue = waterSprayVolume.sprayValue;
        this.materialCarInfo.powerValue = waterSprayVolume.powerValue;
      }
    },
    // 获取现场人员是否佩戴安全帽
    async getPeopleSafety() {
      let getPeopleSafetyUrl =
        CONFIG.requestShed + this.$apiOpt.getPeopleSafety;
      let peopleSafety = await this.$apiUtils.get(getPeopleSafetyUrl, {
        customerId: this.$store.state.customerId,
        time: 1,
      });
      if (peopleSafety) {
        DeleteStaffFunc();
        peopleSafety.forEach((i) => {
          AddStaffFunc(i.posY + ",worker1," + i.posX + "," + i.hasHelmet);
        });
      }
    },
    // 默认字符串截取方法
    substrId(id) {
      return id.substr(0, 3);
    },
    // 开始送料 1
    startPushShed1(id = "0,1") {
      if (
        this.BeltStatus[id[0] + ",2,Belt"] &&
        this.BeltStatus[id[0] + ",2,Belt"].runStatus
      ) {
        switchMaterialCarSim(this.substrId(id) + ",6", true);
        this.openSuccess(id, "皮带开始上料");
        if (this.isCameraFllowA) {
          this.switchCF(false);
          MaterialCarInitCameraPosFunc(this.substrId(id) + ",3");
        }
      }
    },
    // 镜头跟随上料 2.1
    camerawithSPS2(id) {
      this.cw2Timer = setTimeout(() => {
        switchCarCamera(this.substrId(id) + ",20", true);
      }, 5000);
    },
    //数据展示 2-2
    camerawithSPS3(id = "0,1") {
      if (1) {
        this.isCameraIn = true;
        this.getgovernanceRate(
          this.DetectorStatus[this.substrId(id) + ",Detector"].deviceNo
        );
        this.getwaterSprayVolume(
          this.MaterialCarStatus[this.substrId(id) + ",MaterialCar"].deviceNo
        );

        this.$store.commit("changeVideoBoxSwitch", "open");
        let videoObj = this.$shedEquipRelate.videoList.filter((i) => {
          return id.indexOf(i.frontId.substr(0, 3)) > -1;
        })[0];
        let obj = {
          left: "15%",
          top: "22%",
          scale: 0.4,
        };
        this.updateNvrInfoBox(videoObj, obj);
        setTimeout(() => {
          this.$store.commit("changeVideoBoxSwitch", "close");
          this.isCameraIn = false;
          UnlockCameraFunc();
          backToLocationFun("0,0,0");
        }, 15 * 1000);
      } else {
        setTimeout(() => {
          this.camerawithSPS3();
        }, 1000);
      }
    },
    // 物料到达小车上皮带 2
    startPushShed2(id) {
      ContinueMaterialCarSimFunc(this.substrId(id));
    },
    // 物料到达小车下皮带 3
    startPushShed3(id) {
      ContinueMaterialCarSimFunc(this.substrId(id));
    },
    // 物料到达雾炮 4
    stratSpary(id) {
      switchDropMat(this.substrId(id), true);
      if (this.MaterialCarStatus[id]) {
        // switchSpray(this.substrId(id), this.MaterialCarStatus[id].runStatus);
        // if (this.MaterialCarStatus[id].runStatus) {
        //   this.openSuccess(id, "监测到含水率较低，开启干雾治理");
        // }
        setTimeout(() => {
          CreateDropPileFunc(
            this.MaterialCarStatus[id].posAreaID[0] + ",1,5,7"
          );
        }, 10 * 1000);
      }
    },
    // closeCarSim(id) {},
  },
  watch: {
    isCameraFllow() {
      // console.log(this.isCameraFllow);
      this.isCameraFllowA = this.isCameraFllow;
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss'>
.realData {
  .mcInfoBox {
    position: absolute;
    left: 32%;
    top: 30%;
    width: 280px;
    height: 104px;
    background: url("./img/foginfo.png") no-repeat 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 18px;
  }

  .mcInfoBox > div {
    display: flex;
    justify-content: space-around;
  }
  .mcInfoBox > div > :nth-child(1) {
    width: 50%;
    text-align: right;
  }
  .mcInfoBox > div > :nth-child(2) {
    flex: 1;
  }
  .mcInfoAlarmBox {
    position: absolute;
    left: 58%;
    top: 30%;
    width: 300px;
    height: 64px;
    line-height: 64px;
    background: url("./img/foginfo.png") no-repeat;
    background-size: cover;
    display: flex;
    justify-content: space-around;
    font-size: 18px;
  }

  .video-info-wrap {
    position: absolute;
    left: 30%;
    top: 42%;
    width: 421px;
    height: 342px;
    background: #000000;
    box-shadow: 0px 8px 16px 0px rgba(74, 144, 226, 0.31);
    border-radius: 2px;
    border: 1px solid #4a90e2;
    padding: 33px 20px;
    margin-top: 24px;
    box-sizing: border-box;
    .video {
      margin-top: 40px;
    }
  }
}
</style>